import { render, staticRenderFns } from "./PageVault.vue?vue&type=template&id=505654ee&"
import script from "./PageVault.vue?vue&type=script&lang=ts&"
export * from "./PageVault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports